/**
 * @flow
 * @relayHash 0bac7e3767a960bb048325bc6e08f420
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RefreshInput = {|
  token: string,
  clientMutationId?: ?string,
|};
export type TokenRefreshMutationVariables = {|
  input: RefreshInput
|};
export type TokenRefreshMutationResponse = {|
  +refreshToken: ?{|
    +token: ?string
  |}
|};
export type TokenRefreshMutation = {|
  variables: TokenRefreshMutationVariables,
  response: TokenRefreshMutationResponse,
|};
*/


/*
mutation TokenRefreshMutation(
  $input: RefreshInput!
) {
  refreshToken(input: $input) {
    token
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RefreshInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "refreshToken",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RefreshPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "token",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "TokenRefreshMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "TokenRefreshMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "TokenRefreshMutation",
    "id": null,
    "text": "mutation TokenRefreshMutation(\n  $input: RefreshInput!\n) {\n  refreshToken(input: $input) {\n    token\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '51d0ea6d606bd95ddbcc6230f675a7bf';
module.exports = node;
